import { version, name } from '../../package.json'

let client = { name, version, token: null }

function configureClient (config) {
  client = { ...client, ...config }
}

/**
 * Very lightweight wrapper around GraphQL requests using `fetch`.
 * This is intended to make no assumptions about the underlying query but simply
 * to make the request and return the result (or error) from the API.
 * @param {String|{query, variables}[]} query - The raw GraphQL query / body to be sent.
 * @param {Object} variables - Optional parameters when re-using queries.
 * @return {Object|Object[]} response - data object or array of data objects
 */
async function request (query, variables, options) {
  const isDev = process.env.NODE_ENV === 'development'
  const host = process.env.API_HOST || (
    client.env === 'stage'
      ? 'https://api.stage.maxapps.io'
      : 'https://api.maxapps.io'
  )
  const res = await fetch(host + '/graphql', {
    ...options,
    method: 'POST',
    headers: {
      ...(client.token ? { authorization: `Bearer ${client.token}` } : {}),
      'ApolloGraphQL-Client-Name': client.name,
      'ApolloGraphQL-Client-Version': isDev ? 'dev' : client.version,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(Array.isArray(query) ? query : { query, variables })
  })

  if (res.status >= 400) {
    throw new Error(res.status + ': ' + res.statusText)
  }

  return res.json()
}

export { request, configureClient }
